'use strict';
var base = require('./base');
var pdpCarousel = require('../components/pdpCarousel');
var stickyAddToCart = require('../components/stickyAddToCart');

const { handleNotifyMe } = require('./backInStock');

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

/**
 * Move Size attributee
 */
function moveSizeAttributes() {
    $('#collapsible-size-guide').prependTo('.prices-add-to-cart-actions');
    $('[data-attr="size"]').prependTo('.prices-add-to-cart-actions');
    $('#collapsible-size-guide').appendTo('.size-guide');

    if (window.innerWidth > 543) {
        $('[data-attr="size"]').insertBefore('.product-options');
    }
}

/**
 * Hide Size modal
 */
function hideSize() {
    $('.select-size').removeClass('d-none');
    $('.prices-add-to-cart-actions').addClass('d-none');
    $('.modal-background').hide();
}

/**
 * Toggle Notify Me / Add to Cart state
 * @param {boolean} isOutOfStock - true when selected variant is OOS
 */
function toggleNotifyMeState(isOutOfStock) {
    var $notifyMeContainer = $('.notify-me-container');
    var $addToCartWrapper = $('.prices-add-to-cart-actions');

    if (!$notifyMeContainer.length) {
        return;
    }

    if (isOutOfStock) {
        handleNotifyMe($('.js-notify-me'));
        $notifyMeContainer.removeClass('d-none');
        $addToCartWrapper.css('opacity', 0);

        if (window.innerWidth < 543) {
            $('.select-size').removeClass('d-none');
            $('.prices-add-to-cart-actions').addClass('d-none');
            $('.modal-background').hide();
        }
    } else {
        $notifyMeContainer.addClass('d-none');
        $notifyMeContainer.find('.notify-me-form').empty();
        $notifyMeContainer.find('.notify-me-success').remove();
        $addToCartWrapper.css('opacity', 1);
    }
}

$(window).resize(function () {
    moveSizeAttributes();
});

/**
 * Change product images
 */
function changeImages() {
    $('.js-product-main-carousel .slick-slide').each(function () {
        var image = $(this);
        var baseImage = image.find('img');
        if (window.innerWidth > 992) {
            baseImage.attr('src', image.find('.js-product-carousel-item').data('full-image'));
        } else {
            baseImage.attr('src', image.find('.js-product-carousel-item').data('url'));
        }
    });
}

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements,
        toggleNotifyMeState: toggleNotifyMeState
    },

    preselectSizeAndColor: function () {
        $(document).ready(function () {
            var $selectSizeButtons = $('.size-attribute');
            var $selectColorButtons = $('.swatch-value');

            setTimeout(function () {
                if (!$selectColorButtons.hasClass('selected')) {
                    $($('.color-attribute:not(.disabled)')[0]).click();
                }
            }, 1000);

            setTimeout(function () {
                if (!$selectSizeButtons.hasClass('selected')) {
                    $($('.size-attribute:not(.disabled)')[0]).click();
                }

                var $sizeAttributes = $('.size-attribute');
                var $selectedSize = $sizeAttributes.filter('.selected');
                var isSelectedDisabled = $selectedSize.hasClass('disabled');
                var isAllDisabled = $sizeAttributes.length === $sizeAttributes.filter('.disabled').length;

                $('.product-info')
                    .find('.out-of-stock')
                    .toggleClass('d-none', !(isSelectedDisabled || isAllDisabled));
                toggleNotifyMeState(isSelectedDisabled);
            }, 600);
        });
    },

    selectColor: function () {
        $('.color-attribute').on('click', function () {
            var $selectSizeButtons = $('.size-attribute');
            if (!$selectSizeButtons.hasClass('selected')) {
                setTimeout(function () {
                    $($('.size-attribute:not(.disabled)')[0]).click();
                }, 600);
            } else {
                setTimeout(function () {
                    if ($('.size-attribute.selected').hasClass('disabled')) {
                        $($('.size-attribute:not(.disabled)')[0]).click();
                    }
                }, 600);
            }
        });
    },

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail');

            if (data.productType !== 'master') {
                if (data.available) {
                    $('.product-info').find('.out-of-stock').addClass('d-none');
                    toggleNotifyMeState(false);
                } else {
                    $('.product-info').find('.out-of-stock').removeClass('d-none');
                    toggleNotifyMeState(true);
                }
            } else {
                toggleNotifyMeState(false);
            }

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .short-description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .short-description')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                var longDesc = data.longDescription.replace(/#/g, '<br />');

                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(longDesc);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }

            $productContainer.find('.description-and-detail .product-collapse').each(function () {
                var $section = $(this);
                var $content = $section.find('.value.content');

                // Check if section has any text (remove whitespace)
                var text = $content.text().replace(/\s+/g, '').trim();

                if (text.length > 0) {
                    $section.show();  // Show section if content exists
                } else {
                    $section.hide();  // Hide section if empty
                }
            });
        });
    },

    showAttributesAndDetails: function () {
        if ($('.product-collapse').length > 0) {
            $('.product-collapse').each(function () {
                var $section = $(this);
                var $content = $section.find('.value.content');

                // Get the text content and remove whitespace
                var text = $content.text().replace(/\s+/g, '').trim();

                if (text.length > 0) {
                    $section.show();
                }
            });
        }

        var waroWidget = document.querySelector('.waro-widget');
        if (waroWidget) {
            var waroSection = waroWidget.closest('.product-collapse');
            var observer = new MutationObserver(function (mutations, obs) {
                if (waroWidget.children.length > 0) {
                    $(waroSection).show();
                    obs.disconnect();
                }
            });
            observer.observe(waroWidget, { childList: true, subtree: true });
        }
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    },
    updateURL: function () {
        $('body').on('product:updateURL', function (e, data) {
            window.history.replaceState(null, '', data.productUrl);
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            if ($('button.add-to-cart', response.$productContainer).hasClass('disabled-btn')) {
                $('.product-error').remove();
            }

            if (response.product.readyToOrder && response.product.available) {
                $('button.add-to-cart', response.$productContainer).removeClass('disabled-btn');
            } else {
                $('button.add-to-cart', response.$productContainer).addClass('disabled-btn');
            }

            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });

            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.add-to-cart')
                .text($('.add-to-cart').data(response.product.available ? 'msg-addtocart' : 'msg-notify'))
                .toggleClass('js-notify-me', (!response.product.available));

            $('.availability-msg', response.$productContainer)
                .empty().html(response.message);

            if (response.product && response.product.readyToOrder) {
                toggleNotifyMeState(!response.product.available);
            } else {
                toggleNotifyMeState(false);
            }

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) {
                        return $(item).data('available');
                    });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) {
                        return $(item).data('ready-to-order');
                    });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },

    /**
     * Init PDP image carousel
     */
    initProductCarousel: function () {
        var $productContainer = $('.product-detail');
        var slickMainCarousel = $productContainer.find('.js-product-main-carousel');
        var slickThumbnailsMainCarousel = $productContainer.find('.js-slider-nav-thumbnails');

        if ($(slickMainCarousel).hasClass('slick-initialized')) {
            $(slickMainCarousel).slick('unslick');
        }

        if ($(slickThumbnailsMainCarousel).hasClass('slick-initialized')) {
            $(slickThumbnailsMainCarousel).slick('unslick');
        }
        if ($(slickMainCarousel).length > 0) {
            pdpCarousel.createPDPCarousel($productContainer);
        }
    },

    moveSizeAttribute: function () {
        moveSizeAttributes();
    },

    outOfStock: function () {
        if (window.innerWidth < 543) {
            // $('.product-info').find('.out-of-stock').insertAfter('#collapsible-size-guide');
        }
    },

    openSelectSizeModal: function () {
        $('.js-select-size').on('click', function () {
            $('.prices-add-to-cart-actions').removeClass('d-none');
            $('.prices-add-to-cart-actions').css('opacity', 1);
            $('.modal-background').show();
            $('.modal-background').addClass('selectSize');
            $('.select-size').addClass('d-none');
        });
    },

    closeSelectSizeModal: function () {
        $('body').on('product:afterAddToCart', function () {
            hideSize();
        });

        $(document).on('click', '.selectSize, .js-close-add-to-cart', function () {
            hideSize();
        });
    },

    /**
     * Product recommendations carousel
     */
    initRecommendationCarousel: function () {
        var slickMainCarousel = $('.product-recommendation').find('.js-recommendation-carousel');
        if (slickMainCarousel.length > 0) {
            if ($(slickMainCarousel).hasClass('slick-initialized')) {
                $(slickMainCarousel).slick('unslick');
            }

            $(slickMainCarousel).slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                fade: false,
                dots: false,
                infinite: false,
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        dots: true,
                        arrows: false
                    }
                }]
            });
        }
    },

    /**
     * You may also like recommendations carousel
     */
    initYouMayAlsoLikeCarousel: function () {
        /**
         * slick carousel initialization
         * @param {Object} $carousel - jQuery element
         */
        function initEinsteinCarousel($carousel) {
            if ($carousel.hasClass('slick-initialized')) {
                $carousel.slick('unslick');
            }

            $carousel.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                fade: false,
                dots: false,
                infinite: false,
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        dots: true,
                        arrows: false
                    }
                }]
            });
        }

        const $slot = document.querySelector('.carousel-wrapper-element');
        if ($slot) {
            const observer = new MutationObserver(() => {
                const $carousel = $('.carousel-wrapper-element .js-recommendation-carousel');
                if ($carousel.length && $carousel.find('.product').length > 0) {
                    initEinsteinCarousel($carousel);
                    observer.disconnect();
                }
            });
            observer.observe($slot, { childList: true, subtree: true });

            // Disconnect after 10 seconds if nothing loaded
            setTimeout(() => observer.disconnect(), 10000);
        }
    },

    backToPLP: function () {
        $('.js-back-to-plp').on('click', function () {
            history.back();
        });
    },

    changeZoomImages: function () {
        changeImages();
    },

    zoomGalery: function () {
        $(document).on('click', '.js-image', function () {
            var $productContainer = $('.product-detail');
            var slickMainCarousel = $productContainer.find('.js-product-main-carousel:visible');
            var slickThumbnailsMainCarousel = $productContainer.find('.js-slider-nav-thumbnails');
            var activeIndex = slickMainCarousel.find('.slick-current.slick-active').data('slickIndex');

            if (window.innerWidth > 992) {
                $(slickMainCarousel).removeClass('d-lg-none').addClass('js-full-gallery');
                $(slickThumbnailsMainCarousel).removeClass('d-none');
                $('.close-zoom-gallery').removeClass('d-none');
                $('body').css('overflow', 'hidden');

                pdpCarousel.createPDPCarousel($productContainer, activeIndex);

                $('.js-product-carousel-item')
                    .removeClass('js-image')
                    .addClass('js-close-zoom-gallery')
                    .find('.img-fluid')
                    .removeClass('product-images__image');
            }
        });
    },

    closeZoomGallery: function () {
        $(document).on('click', '.js-close-zoom-gallery', function () {
            if (window.innerWidth > 992) {
                var $productContainer = $('.product-detail');
                var slickMainCarousel = $productContainer.find('.js-product-main-carousel:visible');
                var slickThumbnailsMainCarousel = $productContainer.find('.js-slider-nav-thumbnails');
                var activeIndex = slickMainCarousel.find('.slick-current.slick-active').data('slickIndex');

                $(slickMainCarousel).removeClass('js-full-gallery');
                $(slickThumbnailsMainCarousel).addClass('d-none');
                $('.close-zoom-gallery').addClass('d-none');
                $('body').css('overflow', '');

                setTimeout(() => {
                    pdpCarousel.createPDPCarousel($productContainer, activeIndex);

                    $('.js-product-carousel-item')
                        .addClass('js-image')
                        .removeClass('js-close-zoom-gallery')
                            .find('.img-fluid')
                            .addClass('product-images__image');
                }, 10);
            }
        });
    },

    resize: function () {
        var cachedWidth = $(window).width();

        $(window).resize(function () {
            var newWidth = $(window).width();
            if (newWidth !== cachedWidth) {
                var $productContainer = $('.product-detail');

                changeImages();
                pdpCarousel.createPDPCarousel($productContainer);
            }
        });
    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
    stickyAddToCart: stickyAddToCart.init
};
